import APIKeyForm from "../APIKeyForm";

export const APIKeyAdd = (): React.ReactElement => {
  return <APIKeyForm />;
};

export default APIKeyAdd;
